import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  const painPoints = [{
    emoji: '🧠',
    text: 'Tu mente no para cuando te acuestas'
  }, {
    emoji: '😶',
    text: 'Estás presente pero sientes que no estás'
  }, {
    emoji: '😤',
    text: 'Te irritas por cosas pequeñas sin razón'
  }, {
    emoji: '☁️',
    text: 'Niebla mental — no puedes concentrarte ni recordar'
  }, {
    emoji: '😮‍💨',
    text: 'Agotamiento que no desaparece con descanso'
  }, {
    emoji: '💔',
    text: 'Perdiste la motivación por cosas que antes amabas'
  }];
  return <section className="py-20 bg-brand-light-sage" data-id="element-127">
      <div className="max-w-5xl mx-auto px-6" data-id="element-128">
        <FadeIn data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-130">
            ¿Reconoces alguna de estas señales?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-131">
          {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-132">
              <div className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 h-full flex items-start gap-4" data-id="element-133">
                <span className="text-2xl flex-shrink-0" data-id="element-134">{point.emoji}</span>
                <p className="text-brand-charcoal font-medium leading-snug" data-id="element-135">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-136">
          <div className="text-center max-w-2xl mx-auto" data-id="element-137">
            <p className="text-xl md:text-2xl font-bold text-brand-forest leading-relaxed" data-id="element-138">
              Si reconociste 2 o más...
              <br data-id="element-139" />
              tu sistema nervioso lleva demasiado tiempo en modo alerta.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}